import { useEffect, useState } from "react";
import { _BudgetID, _single } from "../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../core/services/dataBean/useDataBean"
import { BasicPage } from "../theme/Component/BasicPage"
import { SelectBudgetType } from "../admin/configuracion/select/SelectBudgetType";
import { YearSelector } from "../../core/shared/inputs/YearSelector";
import { SelectBudgetResource } from "../contract/select/SelectBudgetResource";
import { SelectBudgetSource } from "../admin/configuracion/BudgetSource/SelectBudgetSource";
import { BasicButton } from "../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { PrintJson } from "../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../theme/Component/BasicTable";
import usePaginator from "../theme/Component/usePaginator";
import { SelectBudgetID } from "../admin/configuracion/BudgetID/SelectBudgetID";
import { SelectBudgetTypes } from "../erp/cellEditor/AccountantConcept/SelectBudgetTypes";
import { DropDown } from "../theme/Component/DropDown";
import useModal, { MODAL_XL } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { AdquisitionPlanProject } from "../contract/AdquisitionPlanProject";

export const BudgetLineReport = () => {

    const modalProyectarGraph = useModal("PAA", MODAL_XL);
    const _budget = useDataBean(_BudgetID);
    const { instance, lista, setLista, bean, setBean } = _budget;
    const [data, setData] = useState<any>({});
    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [type, setType] = useState<number>(26);
    const [listaAll, setListaAll] = useState<any>([]);
    const paginador = usePaginator();

    useEffect(() => {
        getBudgetYearByAdquisitionItemProps();
    }, [paginador.page])
    useEffect(() => {
        paginador.setPage(1);
    }, [data])

    const getBudgetYearByAdquisitionItemProps = () => {


        if (year > 0 ) {
            instance.getBudgetYearByAdquisitionItemProps(paginador.page, 15, year, data).then(
                (resp: any) => {
                    if (resp.List) {
                        setLista(resp.List);
                        paginador.setPages(resp.NumberOfPages);
                    }
                }
            ).catch(err => toast.error(err));

        } else {
            toast.warning("Año es obligatorio");
        }
    }
    const getAllBudgetYearByAdquisitionItemProps = () => {


        if (year > 0 ) {
            instance.getBudgetYearByAdquisitionItemProps(1, paginador.pages*15, year, data).then(
                (resp: any) => {
                    if (resp.List) {
                        setListaAll(resp.List);
                        // paginador.setPages(resp.NumberOfPages);
                    }
                }
            ).catch(err => toast.error(err));

        } else {
            toast.warning("Año es obligatorio");
        }
    }

    const head25 = [
        { title: 'ID', property: 'IDAdquisitionItem', visible: true, mask: MASK_NUMBER },
        { title: 'Objecto', property: 'Description', visible: true },
        { title: 'Codigo Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Rubro', property: 'BudgetIDName', visible: true },
        { title: 'Tipo', property: 'BudgetTypeName', visible: true },        
        { title: 'Recurso', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente', property: 'BudgetSourceName', visible: true },
        // { title: 'Vr. Estimado', property: 'EstimatedValue', visible: true, mask: MASK_MONEY },
        { title: 'PI', property: 'PIValue', visible: true, mask: MASK_MONEY },
        { title: 'CC', property: 'CCValue', visible: true, mask: MASK_MONEY },
        { title: 'CDP', property: 'CDPValue', visible: true, mask: MASK_MONEY },
        { title: 'RCDP', property: 'RCDPValue', visible: true, mask: MASK_MONEY },
        { title: 'PF', property: 'PFTotal', visible: true, mask: MASK_MONEY },
        { title: 'RP', property: 'RPValue', visible: true, mask: MASK_MONEY },
        { title: 'RRP', property: 'RRPValue', visible: true, mask: MASK_MONEY },
        { title: 'Saldo CDP', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        // { title: 'AP', property: 'ObValue', visible: true, mask: MASK_MONEY },
        { title: 'Proyeccion', property: 'PYValue', visible: true, mask: MASK_MONEY },

    ]
    const head26 = [
        { title: 'Rubro', property: 'BudgetIDStr', visible: true },
        { title: 'Nombre', property: 'NameBudget', visible: true },
        { title: 'Recurso', property: 'NameBudgetResource', visible: true },
        { title: 'Fuente', property: 'NameBudgetSource', visible: true },
        { title: 'PI', property: 'PIValue', visible: true, mask: MASK_MONEY },
        { title: 'CC', property: 'CCValue', visible: true, mask: MASK_MONEY },
        { title: 'PF', property: 'PFValue', visible: true, mask: MASK_MONEY },
        { title: 'IAD', property: 'IADValue', visible: true, mask: MASK_MONEY },
        // { title: 'AP', property: 'APValue', visible: true, mask: MASK_MONEY },
        { title: 'Proyeccion', property: 'PYValue', visible: true, mask: MASK_MONEY },
    ]
    const actionsDropDown = [
        { id: 0, name: 'Proyectar PAA', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={(e) => {
                            if (e.id == 0) {
                                getAllBudgetYearByAdquisitionItemProps();
                                modalProyectarGraph.open();
                            }
                        }}></DropDown>
                    }

                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Reporte por necesidad">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={year} onChange={(e) => { setYear(e) }} />
                </div>
                {/* <div className="col-md-3">
                    <SelectBudgetTypes label="Tipo Presupuesto" idSelector={type} onChange={(e) => { setType(parseInt(e)) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetType idType={type} idSelector={data.IDBudgetType} onChange={(e) => { setData({ ...data, "IDBudgetType": parseInt(e) }) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetResource idSelector={data.IDBudgetResource} onChange={(e) => { setData({ ...data, "IDBudgetResource": e > 0 ? parseInt(e) : null }) }} />
                </div>
                <div className="col-md-3">
                    <SelectBudgetSource idSelector={data.IDBudgetSource} onChange={(e) => { setData({ ...data, "IDBudgetSource": e > 0 ? parseInt(e) : null }) }} />
                </div>
                <div className="col-md-4">
                    <SelectBudgetID jsonCode={data.BudgetIDStr} onChange={(e) => { setData({ ...data, "BudgetIDStr": e.JsonCode }) }} />
                </div> */}
                <div className="col-md-3">
                    <label>Necesidad</label>
                    <input type="text" name="nes" className="form-control" value={data.Description} onChange={(e) => { setData({ ...data, "Description": e.target.value == '' ? null : e.target.value }) }} />
                </div>
                <div className="col-md-6 ">
                    <BasicButton icon="" useMargin eventClick={getBudgetYearByAdquisitionItemProps}>Buscar</BasicButton>
                </div>
            </div>
            
            <div className="row">
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} head={type == 25 ? head26 : head25} body={lista} rowSet={setBean}
                        pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}
                    ></BasicTable>
                    <Modal modal={modalProyectarGraph.modal} updateModal={modalProyectarGraph.setModal}>
                        <AdquisitionPlanProject lista={listaAll} head={type == 25 ? head26 : head25} />
                    </Modal>
                </div>
            </div>

        </BasicPage>
    )
}